import mitt from 'mitt';

export type Events = {
  formPaymentClicked: any;
};

export const eventBus = mitt<Events>();